"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDControlsSettingsHandler = void 0;
var SDControlsSettingsHandler = /** @class */ (function () {
    function SDControlsSettingsHandler(_api) {
        this._api = _api;
        this._settingUpdateEvents = [];
    }
    SDControlsSettingsHandler.prototype.onSettingUpdate = function (cb) {
        this._settingUpdateEvents.push(cb);
    };
    return SDControlsSettingsHandler;
}());
exports.SDControlsSettingsHandler = SDControlsSettingsHandler;
